import LrrModelBase from '../_generated/modelBases/lrr-model-base';

export default class LrrModel extends LrrModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
